import { render, staticRenderFns } from "./FileUploadDropZone.vue?vue&type=template&id=b07367d0&scoped=true"
import script from "./FileUploadDropZone.vue?vue&type=script&lang=js"
export * from "./FileUploadDropZone.vue?vue&type=script&lang=js"
import style0 from "./FileUploadDropZone.vue?vue&type=style&index=0&id=b07367d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07367d0",
  null
  
)

export default component.exports